/* Extend the existing product radio tabs; load the shared visualizer only on demand. */
(function(){
'use strict';
const configNode=document.getElementById('fg-product-visualizer-config');
if(!configNode||document.getElementById('fg-product-visualizer-tab'))return;
const config=JSON.parse(configNode.textContent);
function init(){
 const tabs=document.querySelector('.fg-no-js .productTabs')||document.querySelector('.productTabs');
 if(!tabs||document.getElementById('fg-product-visualizer-tab'))return;
 const labels=[...tabs.children].filter(n=>n.tagName==='LABEL');
 const anchor=labels.find(n=>/\bdimensions?\b/i.test(n.textContent))||labels.find(n=>/download|drawing/i.test(n.textContent))||labels[labels.length-1];
 let after=anchor?.nextElementSibling;
 while(after&&!after.classList.contains('tab'))after=after.nextElementSibling;
 const existing=tabs.querySelector(':scope > input[type="radio"]');
 if(!after||!existing)return;
 const radio=document.createElement('input');radio.type='radio';radio.name=existing.name;radio.id='fg-product-visualizer-tab';
 const label=document.createElement('label');label.htmlFor=radio.id;label.id='fg-product-visualizer-label';label.textContent='Visualizer';label.tabIndex=0;label.setAttribute('role','button');label.setAttribute('aria-controls','fg-product-visualizer-panel');label.setAttribute('aria-expanded','false');
 const panel=document.createElement('div');panel.className='tab fg-product-visualizer-panel';panel.id='fg-product-visualizer-panel';panel.setAttribute('aria-labelledby',label.id);
 const status=document.createElement('p');status.setAttribute('role','status');status.textContent='Open Visualizer to explore this actuator’s size and motion.';
 const link=document.createElement('a');link.href=config.pageUrl+'?view=actuator-embed&model='+encodeURIComponent(config.family);link.target='_blank';link.rel='noopener';link.textContent='Open full-page visualizer ↗';link.className='fg-product-visualizer-full';
 panel.append(status,link);after.after(radio,label,panel);
 let frame;
 function update(){
  const active=radio.checked;label.setAttribute('aria-expanded',String(active));
  if(!active){frame?.contentWindow?.postMessage({type:'fg-lav-pause'},location.origin);return;}
  if(frame)return;
  frame=document.createElement('iframe');frame.id='fg-product-visualizer-frame';frame.title=config.title+' — interactive actuator visualizer';
  const source=new URL(config.pageUrl+'?view=actuator-embed&model='+encodeURIComponent(config.family),location.href);
  frame.dataset.visualizerSource=source.href;frame.style.height='1100px';
  status.textContent='Loading actuator visualizer…';
  const target=frame;
  frame.addEventListener('load',()=>{if(target.hasAttribute('srcdoc'))status.hidden=true;});
  panel.insertBefore(frame,link);
  // Shopify sends frame-ancestors 'none' for store pages. Fetch our same-origin
  // template, then render our own viewer markup in an isolated srcdoc document.
  fetch(source.href,{credentials:'same-origin'}).then(response=>{if(!response.ok)throw new Error('Viewer unavailable');return response.text();}).then(html=>{
   const doc=new DOMParser().parseFromString(html,'text/html');
   if(!doc.getElementById('fg-lav'))throw new Error('Viewer markup missing');
   const base=doc.createElement('base');base.href=source.href;doc.head.prepend(base);
   target.srcdoc='<!doctype html>'+doc.documentElement.outerHTML;
  }).catch(()=>{if(frame===target){target.remove();frame=null;status.hidden=false;status.textContent='The visualizer could not load. Open the full-page visualizer below, or switch tabs and try again.';}});
 }
 tabs.addEventListener('change',update);
 label.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();label.click();}});
 window.addEventListener('message',event=>{
  if(!frame||event.source!==frame.contentWindow||event.origin!==location.origin)return;
  if(event.data?.type==='fg-lav-height'&&Number.isFinite(event.data.height)&&event.data.height>=300&&event.data.height<=5000){frame.style.height=Math.ceil(event.data.height)+'px';status.hidden=true;}
 });
 update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
